import moment from "moment";
const DATE_FORMAT = "MMMM Do, YYYY";

export default function MiniPlanCard({ plan }: { plan }) {
  return (
    <div className="p-2 gap-1 bg-[#2D6CCA] bg-opacity-10  border-border-gray relative border overflow-hidden cursor-pointer outline-none transition-all w-full select-none rounded-lg">
      <h3 className="text-lg font-semibold text-[#2D6CCA]">
        {plan.programName || plan?.number}
      </h3>
      {plan?.expirationDate && (
        <p className="text-black text-sm font-normal">
          Active until {moment(plan.expirationDate).format(DATE_FORMAT)}
        </p>
      )}
    </div>
  );
}
